export function SupportDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.SUPPORT + '/:param/:param1')
        .setCustomActions({
            'getPreviousBundles': {
                method: 'GET',
                params: {param: 'bundle'},
                isArray: true
            },
            'createBundle': {
                method: 'POST',
                params: {param: 'bundle'},
                notifications: true
            },
            'deleteBundle': {
                method: 'DELETE',
                params: {param: 'bundle', param1: '@bundle_id'},
                notifications: true
            },
            'getEnvInfo': {
                method: 'GET',
                path: '/system/service'
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/support_dao.js